// cart-sync.js

(function () {
  if (window.__SUNHAUK_CART_SYNC_INIT__) return;
  window.__SUNHAUK_CART_SYNC_INIT__ = true;

  let syncTimer = null;
  let isSyncing = false;
  let syncAgain = false;

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function getSectionRequests() {
    const sections = [];

    sections.push({
      requestKey: 'cart-drawer',
      targetId: 'cart-drawer',
      selector: '#CartDrawer',
      type: 'drawer'
    });

    sections.push({
      requestKey: 'cart-icon-bubble',
      targetId: 'cart-icon-bubble',
      selector: '.shopify-section',
      type: 'replace-inner'
    });

    sections.push({
      requestKey: 'cart-live-region-text',
      targetId: 'cart-live-region-text',
      selector: '.shopify-section',
      type: 'replace-inner'
    });

    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems && mainCartItems.dataset.id) {
      sections.push({
        requestKey: mainCartItems.dataset.id,
        targetId: 'main-cart-items',
        selector: '.js-contents',
        type: 'replace-inner'
      });
    }

    if (mainCartFooter && mainCartFooter.dataset.id) {
      sections.push({
        requestKey: mainCartFooter.dataset.id,
        targetId: 'main-cart-footer',
        selector: '.js-contents',
        type: 'replace-inner'
      });
    }

    return sections;
  }

  function replaceSection(targetId, selector, html) {
    const target = document.getElementById(targetId);
    if (!target || !html) return;

    const doc = parseHTML(html);

    const newElement =
      doc.querySelector(selector) ||
      doc.getElementById(targetId) ||
      doc.querySelector('#' + targetId);

    const currentElement = target.querySelector(selector) || target;

    if (newElement && currentElement) {
      currentElement.innerHTML = newElement.innerHTML;
    }
  }

  function updateBubble(html) {
    const bubbleHost = document.getElementById('cart-icon-bubble');
    if (!bubbleHost || !html) return;

    const doc = parseHTML(html);

    const newBubbleHost =
      doc.getElementById('cart-icon-bubble') ||
      doc.querySelector('#cart-icon-bubble');

    const newSection = doc.querySelector('.shopify-section');

    if (newBubbleHost) {
      bubbleHost.innerHTML = newBubbleHost.innerHTML;
      return;
    }

    if (newSection) {
      bubbleHost.innerHTML = newSection.innerHTML;
      return;
    }

    const newCountBubble = doc.querySelector('.cart-count-bubble');
    const currentCountBubble = bubbleHost.querySelector('.cart-count-bubble');

    if (newCountBubble && currentCountBubble) {
      currentCountBubble.innerHTML = newCountBubble.innerHTML;
      return;
    }

    if (newCountBubble && !currentCountBubble) {
      bubbleHost.appendChild(newCountBubble);
      return;
    }

    if (!newCountBubble && currentCountBubble) {
      currentCountBubble.remove();
    }
  }

  function syncCartPageEmptyState() {
    const cartRoot = document.querySelector('cart-items.cart-page-v2');
    const emptyState = document.querySelector('.cart-page-v2-empty');
    const titleRow = document.querySelector('.cart-page-v2__title-row');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (!cartRoot || !emptyState) return;

    const isEmpty = !emptyState.hasAttribute('hidden');

    cartRoot.classList.toggle('is-empty', isEmpty);
    cartRoot.classList.toggle('is-full', !isEmpty);

    if (titleRow) {
      titleRow.hidden = isEmpty;
    }

    if (mainCartFooter) {
      mainCartFooter.classList.toggle('is-empty', isEmpty);
    }
  }


  function updateCartDrawerSilently(sectionHtml) {
  const drawer =
    document.querySelector('cart-drawer.cart-drawer-v2') ||
    document.querySelector('cart-drawer');

  if (!drawer || !sectionHtml) return;

  const doc = parseHTML(sectionHtml);

  const newDrawerInner =
    doc.querySelector('.drawer__inner') ||
    doc.querySelector('#CartDrawer .drawer__inner');

  const currentDrawerInner = drawer.querySelector('.drawer__inner');

  if (newDrawerInner && currentDrawerInner) {
    currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
  }

  if (
    window.SunhaukCartDrawerV2 &&
    typeof window.SunhaukCartDrawerV2.sync === 'function'
  ) {
    window.SunhaukCartDrawerV2.sync(drawer);
  }
}


// ----------------------------------------------Code added for cart-drawer image flicker issue (S)--------------------------------
function isDrawerOrigin(detail) {
  var source = detail && detail.source ? String(detail.source) : '';

  return (
    source.indexOf('cart-drawer') === 0 ||
    source.indexOf('cart-drawer-v2') === 0 ||
    source.indexOf('cart-drawer-v2-liquid') === 0
  );
}
// ----------------------------------------------Code added for cart-drawer image flicker issue (E)--------------------------------


// ----------------------------------------------Code added for cart-page image flicker issue (S)--------------------------------
function isCartPageOrigin(detail) {
  var source = detail && detail.source ? String(detail.source) : '';

  return (
    source.indexOf('cart-page') === 0 ||
    source.indexOf('cart-page-v2') === 0 ||
    source.indexOf('cart-items') === 0
  );
}
// ----------------------------------------------Code added for cart-page image flicker issue (E)--------------------------------



  async function refreshNow(detail) {
    if (isSyncing) {
      syncAgain = true;
      return;
    }

    isSyncing = true;

    try {
      const sectionRequests = getSectionRequests();
      const sectionIds = sectionRequests.map((section) => section.requestKey);

      if (!sectionIds.length) return;

      const response = await fetch('/cart?sections=' + sectionIds.join(','), {
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Cart sync sections request failed');

      const data = await response.json();

     const drawer =
  document.querySelector('cart-drawer.cart-drawer-v2') ||
  document.querySelector('cart-drawer');

// if (drawer && data['cart-drawer']) {
//   updateCartDrawerSilently(data['cart-drawer']);
// }

// ----------------------------------------------Code added for cart-drawer image flicker issue (S)--------------------------------
     if (drawer && data['cart-drawer'] && !isDrawerOrigin(detail)) {
  updateCartDrawerSilently(data['cart-drawer']);
}
// ----------------------------------------------Code added for cart-drawer image flicker issue (E)--------------------------------


      sectionRequests.forEach(function (section) {
  const html = data[section.requestKey];
  if (!html) return;

  if (section.requestKey === 'cart-icon-bubble') {
    updateBubble(html);
    return;
  }

  if (section.type === 'drawer') return;

  // ----------------------------------------------Code added for cart-page image flicker issue (S)--------------------------------
  const isMainCartSection =
    section.targetId === 'main-cart-items' ||
    section.targetId === 'main-cart-footer';

  /*
    If the cart action started from the cart page, cart.js/cart-page-v2.js
    already refreshed the cart page once. Do not replace it again here,
    otherwise mobile cart images flicker twice.
  */
  if (isMainCartSection && isCartPageOrigin(detail)) {
    return;
  }
  // ----------------------------------------------Code added for cart-page image flicker issue (E)--------------------------------

  replaceSection(section.targetId, section.selector, html);
});


// ----------------------------------------------Code added for cart-drawer image flicker issue (S)--------------------------------

      if (
  drawer &&
  !isDrawerOrigin(detail) &&
  window.SunhaukCartDrawerV2 &&
  typeof window.SunhaukCartDrawerV2.sync === 'function'
) {
  window.SunhaukCartDrawerV2.sync(drawer);
}
// ----------------------------------------------Code added for cart-drawer image flicker issue (E)--------------------------------


      syncCartPageEmptyState();

      document.dispatchEvent(
        new CustomEvent('sunhauk:cart-surfaces-refreshed', {
          detail: detail || {}
        })
      );
    } catch (error) {
      console.error('Sunhauk cart sync failed:', error);
    } finally {
      isSyncing = false;

      if (syncAgain) {
        syncAgain = false;
        refreshNow({ source: 'queued-sync' });
      }
    }
  }

  function refresh(detail) {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(function () {
      refreshNow(detail || {});
    }, 120);
  }

  window.SunhaukCartSync = {
    refresh: refresh,
    refreshNow: refreshNow
  };

  document.addEventListener('sunhauk:cart:changed', function (event) {
    refresh(event.detail || {});
  });
})();